import { render } from "./NotFound.vue?vue&type=template&id=d2764d34"
const script = {}
script.render = render

export default script